import React, { useLayoutEffect, useState, useEffect } from "react";
import ButtonBlock from "./ButtonBlock";

const HeroSlider = ({ title, subtitle, buttonText, buttonLink, background, mobileBackground }) => {
  const [sectionHeight, setSectionHeight] = useState("100svh");
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth <= 768);
    };
    
    checkMobile();
    window.addEventListener('resize', checkMobile);
    
    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  useLayoutEffect(() => {
    const navbar = document.querySelector(".navbar-wrapper");
    // if (navbar) {
    //   const navbarHeight = navbar.offsetHeight;
    //   // setSectionHeight(`calc(100svh - ${navbarHeight}px)`);
    // } else {
    //   setSectionHeight("100svh");
    // }
  }, []);

  const activeBackground = isMobile && mobileBackground ? mobileBackground : background;

  return (
    <div className="hcs-hero-section" style={{ height: sectionHeight }}>
      {/* Video Background */}
      {activeBackground?.type === "video" && (
        <div className="section__video-background">
          <video
            className="section__background-video-hosted"
            autoPlay
            loop
            muted
            playsInline
          >
            <source src={activeBackground.url.publicURL} type="video/mp4" />
          </video>
        </div>
      )}

      <div className="section__content">
        <div className="section__content-inner">
          <div className="section-subtitle">{subtitle}</div>
          <h2 className="section-title">{title}</h2>
          <ButtonBlock
            text={buttonText}
            link={buttonLink}
          />
        </div>
      </div>
    </div>
  );
};

export default HeroSlider;
